var Model = require('../Model');

var Dashboard = Object.create(Model);

Dashboard.name = 'Dashboard';
Dashboard['@class'] = 'Dashboard';
Dashboard.url = 'dashboard';
Dashboard.fields = {
  parent: {
    default: null
  },
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  masonry: {
    type: 'select',
    default: 1,
    options: [
      {name: 'On', value: 1},
      {name: 'Off', value: 0}
    ]
  },
  useHasDashboardEdge: {
    default: false
  },
  permissionClasses: {
    default: [],
    hidden: true
  },
};

module.exports = Dashboard;